/* eslint-disable @typescript-eslint/consistent-type-assertions */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
import { Container } from '@mui/material'
import { generatePath, useNavigate, useParams } from 'react-router'
import { type PortalChildDetails, type EnrollmentDetails, type PortalCaregiverDetails, type PortalService, type lookup } from 'core/types'
import { CAREGIVER_PORTAL } from 'Pages/Routes'
import { CaregiverShortForm } from 'Pages/CaregiverPortal/ShortForm/CaregiverShortForm'
import { type CaregiverShortFormState } from 'Pages/CaregiverPortal/types'
import { checkAccountExists, deleteSession, useCaregiverWizardContext, useCaregiverWizardUpdateDispatch } from 'ContextProviders/CaregiverWizard'
import { AccountFound } from 'Pages/CaregiverPortal/InterestForm/Step2/AccountFound'
import { parseAddress } from 'Pages/CaregiverPortal/PortalHelpers'
import { useEffect, useState } from 'react'
import { sendGet } from 'hooks/use-fetch'

export function AccountCheck (): JSX.Element {
  const dispatch = useCaregiverWizardUpdateDispatch()
  // const [backwards, setBackwards] = useState<boolean>(false)
  const [languageList, setLanguageList] = useState<lookup[]>([])

  const { isdId, isdServiceProviderId } = useParams()
  const caregiverForm: EnrollmentDetails = useCaregiverWizardContext() ?? {} as EnrollmentDetails
  const nav = useNavigate()
  useEffect(() => {
    const fetchData = async (): Promise<void> => {
      const { response: languages } = await sendGet('/Language/GetLookup?sort=true', {})
      setLanguageList(languages ?? [])
    }
    void fetchData()
  }, [])

  const handleBack = (): void => {
    deleteSession()
    dispatch({ type: 'form', form: null })

    const portalRoute = generatePath(CAREGIVER_PORTAL, { isdId: isdId ?? '', isdServiceProviderId: isdServiceProviderId ?? '' })
    nav(portalRoute)
  }

  const handleContinue = async (): Promise<void> => {
    const tempForm = { ...caregiverForm }
    const tempCaregiver = { ...tempForm.caregivers[0] }
    tempCaregiver.email = tempCaregiver.email.trim()
    const location = parseAddress(tempCaregiver.location.address)
    tempCaregiver.location = location
    const requestedServices: PortalService[] = []
    tempForm.children = [{
      isCurrentlyUpdating: true,
      requestedServices,
      location,
      firstName: '',
      lastName: '',
      dateOfBirth: null,
      languageID: null,
      isHomeless: false,
      unborn: false
    } as PortalChildDetails]
    tempForm.currentChild = tempForm.children[0]
    const accountExists = await checkAccountExists(tempCaregiver.email)
    if (accountExists) {
      tempForm.currentSubStep = 2
    } else {
      tempForm.currentStep = 1
      tempForm.currentSubStep = 2
    }
    dispatch({ type: 'form', form: tempForm })
  }

  const cgDat = caregiverForm.caregivers[0] ?? {
    firstName: '',
    lastName: '',
    dateOfBirth: null,
    relationshipId: null,
    hasFinancialResponsibility: false,
    primaryPhone: '',
    secondaryPhone: null,
    email: '',
    doesNotHaveEmail: false,
    preferredContactMethod: null,
    educationLevelID: null,
    isLivingWithStudent: false,
    location: {
      address: '',
      apartment: '',
      city: '',
      state: '',
      zipCode: ''
    },
    isCurrentlyUpdating: false,
    primaryLanguageId: null

  }
  return <Container>
    {caregiverForm.currentSubStep !== 2 && (
      <CaregiverShortForm
        disableNoEmail
        disableHomeless
        disableNoPhone
        pageState={{
          address: cgDat.location.address,
          phone: cgDat.primaryPhone ?? '',
          currentlyHomeless: false,
          doesNotHaveEmail: false,
          doesNotHavePhone: false,
          email: cgDat.email,
          firstName: cgDat.firstName,
          lastName: cgDat.lastName,
          preferredContactMethodId: cgDat.preferredContactMethod,
          primaryLanguageId: cgDat.primaryLanguageId,
          secondaryPhone: cgDat.secondaryPhone
        } as CaregiverShortFormState}
        languageList={languageList}
        setPageState={(state: CaregiverShortFormState) => {
          const tempCaregiver: PortalCaregiverDetails = {
            ...cgDat,
            firstName: state.firstName,
            lastName: state.lastName,
            dateOfBirth: null,
            relationshipId: null,
            hasFinancialResponsibility: true,
            primaryPhone: state.phone,
            secondaryPhone: state.secondaryPhone ?? '',
            email: state.email,
            doesNotHaveEmail: state.doesNotHaveEmail,
            preferredContactMethod: state.preferredContactMethodId,
            educationLevelID: null,
            isLivingWithStudent: true,
            location: {
              address: state.address,
              apartment: '',
              city: '',
              state: '',
              zipCode: ''

            },
            isCurrentlyUpdating: true,
            primaryLanguageId: state.primaryLanguageId
          }

          const tempForm = {
            ...caregiverForm,
            caregivers: [tempCaregiver]
          }
          dispatch({ type: 'form', form: tempForm })
        }}
        onContinue={handleContinue}
        onBack={handleBack}
      />
    )}
    {caregiverForm.currentSubStep === 2 && (
      <AccountFound />
    )}
  </Container>
}
